import { encode } from "base-64";
import useSWR from "swr";
import { ConsentConfig } from "../helpers/const";
import { useTranslation } from "react-i18next";
 
export function useConsent(id) {
  const { i18n } = useTranslation();
  let langCode = i18n.language?.toUpperCase() || "TR";
 
  const swrUri = ConsentConfig.find(
    (c) => c.lang === langCode && c.id === id
  )?.uri;
 
  const fetcher = (url) =>
    fetch(url, {
      method: "GET",
      headers: {
        Authorization:
          "Basic " +
          encode(
            process.env.REACT_APP_CMS_USERNAME +
              ":" +
              process.env.REACT_APP_CMS_PASSWORD
          ),
      },
    }).then((res) => res.json());
 
  const { data, isLoading } = useSWR(swrUri, fetcher);
 
  return { data, isLoading };
}